const lookupTypeMap: Record<number, string> = {
  1: "ORGANIZATION",
  2: "USER",
  3: "GROWING_SEASON",
  4: "PRODUCT_TYPE",
};

export const getLookupTypeLabel = (type: number) =>
  lookupTypeMap[type] ?? "UNKNOWN";
